import { getToken, setToken, removeToken, getUser, setUser, removeUser } from '@/utils/auth'
import { getPermissions } from '@/api/request'

export default {
  state: {
    token: getToken(),
    user: getUser(),
    permissions: []
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
    },
    SET_USER(state, user) {
      state.user = user
      setUser(user)
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    REMOVE_TOKEN(state) {
      state.token = null
      state.user = null
      state.permissions = []
      removeToken()
      removeUser()
    }
  },
  actions: {
    login({ commit }, { token, user }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
    },
    logout({ commit }) {
      commit('REMOVE_TOKEN')
    },
    fetchPermissions({ commit }) {
      return getPermissions().then(res => {
        commit('SET_PERMISSIONS', res.data || [])
      }).catch(() => {
        commit('SET_PERMISSIONS', [])
      })
    }
  }
}
